var curHostA = window.location.href
var curHost = window.location.host
var pre = curHostA.split('://')[0]
var basicUrl = pre + '://' + curHost
var wxUrl = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxc002bde145623f26&redirect_uri=' + encodeURIComponent('http://www.rhawn.cn/author/index') + '&response_type=code&scope=snsapi_base&state=1#wechat_redirect'
if (window.location.href.indexOf('localhost') > -1) {
	//测试地址
	var basicParam = {
		basicUrl: 'https://www.rhawn.cn/api/',
		partner:'wap',
		apikey:'2a7f1044c9abad10b6d39aa85c37197b',
		ERROROK: 1,
		wxUrl: wxUrl
	};
} else if (window.location.href.indexOf('www.rhawn.cn') > -1){
		//正式地址
		var basicParam = {
			basicUrl: 'https://www.rhawn.cn/api/',
			partner:'wap',
			apikey:'2a7f1044c9abad10b6d39aa85c37197b',
			ERROROK: 1,
			wxUrl: wxUrl
		};
	} else {
		//测试地址
		var basicParam = {
			basicUrl: 'https://www.rhawn.cn/api/',
			partner:'wap',
			apikey:'2a7f1044c9abad10b6d39aa85c37197b',
			ERROROK: 1,
			wxUrl: wxUrl
		};
	}

	export default basicParam;


//////////////////
// WEBPACK FOOTER
// ./static/config/systemConfig.js
// module id = yiBO
// module chunks = 1